module.exports = __webpack_public_path__ + "img/ldap.c10c51ac.svg";